var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemove01 = function SvgRemove01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "remove-01_svg2__a",
    x1: 29.18,
    x2: 171.11,
    y1: 174.67,
    y2: 25.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#remove-01_svg2__a",
    id: "remove-01_svg2__b",
    x1: 28.81,
    x2: 170.74,
    y1: 174.31,
    y2: 24.66
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100 0C44.86 0 0 44.86 0 100s44.86 100 100 100 100-44.86 100-100S155.14 0 100 0m0 184.51c-46.59 0-84.51-37.91-84.51-84.51S53.41 15.49 100 15.49 184.51 53.4 184.51 100 146.6 184.51 100 184.51",
    style: {
      fill: "url(#remove-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73 91.56H61.17a7.75 7.75 0 0 0 0 15.5h77.56a7.75 7.75 0 0 0 0-15.5",
    style: {
      fill: "url(#remove-01_svg2__b)"
    }
  }));
};
export default SvgRemove01;